"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const helpers_1 = require("./helpers");
const react_promise_tracker_1 = require("react-promise-tracker");
const LoadingIndicator_1 = __importDefault(require("./LoadingIndicator"));
function Paginator(props) {
    var _a, _b, _c;
    const apiCall = props.apiCall;
    const update = props.update;
    const log = props.log;
    const includeURLSearchParams = props.includeURLSearchParams;
    const [data, setdata] = props.useState;
    const [page_size, setpage_size] = react_1.default.useState((_a = props.page_size) !== null && _a !== void 0 ? _a : 10);
    function fetchData(link = null, params = null) {
        let linkParams = Object.fromEntries(new URLSearchParams(link === null || link === void 0 ? void 0 : link.split('?')[1]));
        let allParams = Object.assign(Object.assign(Object.assign({}, linkParams), params), { page_size: page_size });
        // console.log('Paginator fetchData', link)
        (0, react_promise_tracker_1.trackPromise)((0, helpers_1.ApiCallHandler)(() => { setdata([]); return apiCall(allParams); }, (data) => { setdata(data); setpage_size(data.per_page); }, log !== null && log !== void 0 ? log : 'Paginator fetchData', log ? true : false));
    }
    react_1.default.useEffect(() => {
        var params = includeURLSearchParams ? Object.fromEntries(new URLSearchParams(location.search)) : {};
        fetchData(null, params);
    }, [update, page_size]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'd-flex align-items-center' },
            react_1.default.createElement("div", { className: 'my-1 mx-2' },
                'العدد الكلي',
                ": ", data === null || data === void 0 ? void 0 :
                data.total),
            react_1.default.createElement("div", { className: 'd-flex align-items-center my-2' },
                react_1.default.createElement("select", { value: page_size, onChange: e => {
                        setpage_size(+e.target.value);
                    } },
                    react_1.default.createElement("option", { value: 5 }, "5"),
                    react_1.default.createElement("option", { value: 10 }, "10"),
                    react_1.default.createElement("option", { value: 15 }, "15"),
                    react_1.default.createElement("option", { value: 20 }, "20"),
                    react_1.default.createElement("option", { value: 25 }, "25"),
                    react_1.default.createElement("option", { value: 50 }, "50"),
                    react_1.default.createElement("option", { value: 100 }, "100"),
                    react_1.default.createElement("option", { value: 250 }, "250"),
                    react_1.default.createElement("option", { value: 500 }, "500")))),
        react_1.default.createElement(react_bootstrap_1.Pagination, { size: "sm" },
            react_1.default.createElement(LoadingIndicator_1.default, null),
            // if only one page don't show links
            ((_b = data === null || data === void 0 ? void 0 : data.links) === null || _b === void 0 ? void 0 : _b.length) != 3 ?
                (_c = data === null || data === void 0 ? void 0 : data.links) === null || _c === void 0 ? void 0 : _c.map((link, index) => {
                    if (link['url'] && index == 0) {
                        return react_1.default.createElement(react_bootstrap_1.Pagination.Prev, { key: index, onClick: () => fetchData(link['url']) }, "\u0627\u0644\u0633\u0627\u0628\u0642");
                    }
                    if (link['url'] && index == (data === null || data === void 0 ? void 0 : data.links.length) - 1) {
                        return react_1.default.createElement(react_bootstrap_1.Pagination.Next, { key: index, onClick: () => fetchData(link['url']) }, "\u0627\u0644\u062A\u0627\u0644\u064A");
                    }
                    if (link['url'] && index && index != (data === null || data === void 0 ? void 0 : data.links.length) - 1)
                        return react_1.default.createElement(react_bootstrap_1.Pagination.Item, { active: link.active, key: index, onClick: () => fetchData(link['url']) }, link['label']);
                }) : null)));
}
exports.default = Paginator;
